import { makeStyles } from "@material-ui/core/styles";

export const simpleTableStyles = makeStyles((theme) => ({
  actionsContainer: {
    display: "flex",
    paddingBottom: 20,
    alignItems: "center",
    justifyContent: "space-between",
  },
  primaryActionsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    "@media (max-width: 1120px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
    },
  },
  primaryActionContainer: {
    "@media (max-width: 1120px)": {
      marginTop: -15,
      marginBottom: 30,
    },
  },
  searchFieldContainer: {
    display: "flex",
    alignItems: "center",
  },
  toolbarActionButton: {
    margin: "0 10px",
    fontWeight: "bold",
    padding: "9px 18px",
    textTransform: "none",
    color: theme.palette.text.primary,
  },
  multiSelectButton: {
    zIndex: 999,
  },
  multiSelectAlert: {
    height: 30,
    marginLeft: 10,
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.info.main,
    "&.attention": {
      animation: "scale-shake 1s linear",
    },
    "& span": {
      color: theme.palette.primary.main,
    },
  },
  alignRightAction: {
    position: "absolute",
    right: 0,
  },
  paginationContainer: {
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  multiselectContainer: {
    display: "flex",
    alignItems: "center",
  },
  multiSelectionText: {
    fontSize: "0.875rem",
    margin: `0 !important`,
  },
  table: {
    minWidth: 450,
    borderRadius: 5,
    boxShadow: "none",
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  tableRow: {
    cursor: "pointer",
  },
  tableRowEmpty: {
    backgroundColor: theme.palette.background.paper,
  },
  actions: {
    padding: theme.spacing(0.5),
  },
  tableSortLabel: {
    fontWeight: "bold",
    "&:focus": {
      border: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.paper,
      borderRadius: 2,
    },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  titleBar: {
    width: "fit-content",
    flex: "1 1 100%",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  toolBar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  toolBarSearchOnly: {
    padding: 0,
  },
  tableCell: {
    maxWidth: 400,
    wordWrap: "break-word",
    "& pre": {
      whiteSpace: "pre-wrap",
      color: theme.palette.text.primary,
    },
    "&:hover": {
      background: theme.palette.action.hover,
    },
    "&:hover $tableCellAction": {
      display: "initial",
    },
  },
  tableCellEmpty: {
    color: theme.palette.text.secondary,
    textAlign: "center",
    paddingTop: 40,
    paddingBottom: 40,
  },
  tableCellAction: {
    display: "none",
  },
  newSearchField: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  linkLi: {
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    "& a": {
      color: theme.palette.text.primary,
      paddingTop: 6,
      paddingBottom: 6,
      paddingRight: 16,
      paddingLeft: 16,
      textDecoration: "none",
      width: "100%",
    },
  },
  simpleTableTitleContainer: {
    display: "flex",
    alignItems: "center",
    "& p": {
      fontSize: 22,
      marginRight: 5,
      marginBottom: 5,
      fontWeight: "bold",
    },
  },
  tooltip: {
    boxShadow: theme.shadows[4],
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  disabledMenuItem: {
    color: theme.palette.text.secondary,
  },
  buttonLi: {
    padding: 0,
  },
  menuItemButton: {
    padding: 0,
    fontSize: "16px",
    "& span": {
      width: "100%",
      padding: "6px 16px",
      justifyContent: "flex-start",
    },
  },
  titleTooltipIcon: {
    fill: theme.palette.primary.main,
  },
}));
